/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteProductionOrderSetupWasteEntry } from '../../models/delete-production-order-setup-waste-entry';

export interface DeleteProductionOrderSetupWaste$Params {
  productionOrderId: number;
      body: DeleteProductionOrderSetupWasteEntry
}

export function deleteProductionOrderSetupWaste(http: HttpClient, rootUrl: string, params: DeleteProductionOrderSetupWaste$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteProductionOrderSetupWaste.PATH, 'post');
  if (params) {
    rb.path('productionOrderId', params.productionOrderId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteProductionOrderSetupWaste.PATH = '/api/v1/ProductionOrder/{productionOrderId}/DeleteSetupWasteFromProductionOrder';
